import { Box, Typography } from "@mui/material";

export default function Monitoring() {
  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={3}
      >
        <Box>
          <Typography variant="h4" component="h1" fontWeight={700}>
            Monitoring{" "}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
